<template>
    <b-row>
        <div class="d-flex mt-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">{{ $t('GenericandManufacturing.title') }}</h6>
        </div>
    </b-row>
    <!-- {{ dataObj }} -->

    <b-row class="my-2 ps-3">
        <b-col sm="12" md="12" lg="12" xl="10">
            <b-row>

                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column">
                    <label class="display-field-label mb-2">{{ $t('GenericandManufacturing.manufacturer') }}</label>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column mb-5">
                    <span class="details-circle-common">{{ dataObj.ManufactureName }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column">
                    <label class="display-field-label mb-2">{{ $t('GenericandManufacturing.generic') }}</label>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column mb-5">
                    <span v-if="dataObj.ItemGenericName != ''" class="details-circle-common">{{ dataObj.ItemGenericName
                        }}</span>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column">
                    <label class="display-field-label mb-2">{{ $t('GenericandManufacturing.title') }}</label>
                </b-col>
                <b-col lg="12" md="12" sm="12" cols="12" class="form-field-column mb-5">
                    <span class="details-circle-common">Cardiology Sub-Store</span>
                </b-col>
            </b-row> -->
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss">
.details-circle-common {
    border-radius: 20px;
    background-color: #FEECDE;
    min-width: 300px;
    width: auto;
    padding: 7px 14px;
}
</style>